/* Simple, single pop-up box for 'more info' type things. Uses the first parent with a relative position for layout */
<template>
   <div>
      <button
         aria-haspopup="true"
         :aria-expanded="state.expanded"
         :aria-label="props.buttonAria"
         data-cy="popup-button"
         class="flex items-center"
         @click="state.expanded = !state.expanded"
      >
         <slot name="button-content"></slot>
      </button>
      <transition name="fade-down">
         <div v-show="state.expanded" class="w-68 absolute right-0 top-0 z-100 mt-8 md:w-96">
            <slot name="popup-content"></slot>
         </div>
      </transition>
   </div>
</template>

<script setup lang="ts">
// Props
const props = defineProps<{
   buttonAria?: string;
}>();

const state = reactive({
   expanded: false,
});
</script>

<style scoped>
.fade-down-enter-active,
.fade-down-leave-active {
   transition: opacity 0.3s ease-in-out;
}

.fade-down-leave-to,
.fade-down-enter-from {
   opacity: 0;
}
</style>
